module.exports = __webpack_public_path__ + "img/CIO200_1-1.d4f7deb2.jpg";